import { Stack, Typography } from "@mui/material";
import { useContext, useState, useCallback, FormEvent } from "react";
import { AuthContext } from "../../context/auth.context";
import { Conditions } from "../static";
import { LoginFooter } from "../footer";
import { ConfigurationContext } from "../../App";

export const Registered = ({ email }: { email?: string }) => {
  const { user, register } = useContext(AuthContext);
  const [{ firstName, secondName, surname, phone, password, password2 }, setCredentials]
      = useState({ firstName: '', secondName: '', surname: '', phone: '', password: '', password2: '' });

  const handleSubmit = useCallback((e: FormEvent) => {
    e.preventDefault();

    register(email!, password, password2, firstName, secondName, surname, phone);
  }, [email, firstName, secondName, surname, phone, password, password2, register]);

  const [config] = useContext(ConfigurationContext);

  return (
    <form onSubmit={handleSubmit}>
      <Stack maxWidth="816px" padding="3rem" spacing={4}>
        <Typography variant="h1">Проверьте электронную почту</Typography>

        <Typography>Мы отправили вам письмо для подтверждения идентификации в приложении ШифроПочта.</Typography>
        <Typography>Когда получите это сообщение, щелкните ссылку, чтобы подтвердить свой адрес электронной почты.</Typography>
        <Typography>Срок действия ссылки ограничен по соображениям безопасности.</Typography>
        <Typography><Typography component="span" fontWeight="500">Примечание: Если вы не получите это сообщение на свой адрес электронной почты в течение нескольких минут, проверьте папку нежелательной почты.</Typography></Typography>
        <Typography>Теперь вы можете закрыть окно.</Typography>
        <Typography><i>{`Это сообщение будет получено от ШифроПочты <${config?.defaultSupportEmail}>.`}</i></Typography>

        <LoginFooter />
        
        <Conditions />
      </Stack>
    </form>
  )
}
